import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useRouteMatch } from 'react-router';

import { selectUserPermissions } from '../../../store/modules/user-permissions/selectors';
import { useActionDispatcher } from '../../../hooks';
import {
  initUserPermissionsRequest,
  createUserPermissionsRequest,
  clearSelectedUserPermissionsList,
} from '../../../store/modules/user-permissions/actions';
import TeamForm from './TeamForm';
import { clipLastSegmentRoute } from '../../../utility/path';

type Props = {
  setIsOpenModal: (value: boolean) => void;
};

const TeamCreate = ({ setIsOpenModal }: Props) => {
  const dispatch = useDispatch();
  const { url, params } = useRouteMatch<{id: string}>();
  const organizationId = parseInt(params.id, 10);

  useEffect(() => () => {
    dispatch(clearSelectedUserPermissionsList());
  }, [dispatch]);

  if (!organizationId) {
    dispatch(push('/dashboard'));
  }

  const userPermissions = useSelector(selectUserPermissions);

  if (userPermissions.data && organizationId) {
    userPermissions.data.organization_id = organizationId;
  }

  useEffect(() => {
    dispatch(initUserPermissionsRequest());
  }, [dispatch]);

  const createUserPermissions = useActionDispatcher(createUserPermissionsRequest);

  useEffect(() => {
    if (userPermissions.redirect && userPermissions.data) {
      const to = clipLastSegmentRoute(url);
      dispatch(push(to));
    }
  }, [userPermissions, dispatch, url]);

  return (
    <TeamForm
      titleSubmit="Send Invite"
      creatingMode
      record={userPermissions}
      onSubmit={createUserPermissions}
      setEmailFromSearch
      setIsOpenModal={setIsOpenModal}
    />
  );
};

export default TeamCreate;
